import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import API_BASE_URL from "../config/api";
import Swal from "sweetalert2";
function PaperCategory() {

    /*
    |--------------------------------------------------------------------------
    | State
    |--------------------------------------------------------------------------
    */

    const [categories, setCategories] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const [search, setSearch] = useState("");

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;


    /*
    |--------------------------------------------------------------------------
    | Fetch Paper Categories
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        fetchCategories();

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Fetch Categories
    |--------------------------------------------------------------------------
    */

    const fetchCategories = async () => {

        try {

            setLoading(true);

            setError("");


            const response = await fetch(
                
                `${API_BASE_URL}/admin/paper-category`,
                {
                    method: "GET",

                    headers: {
                        "Accept": "application/json"
                    },

                    /*
                    |--------------------------------------------------------------------------
                    | Admin Session / Cookie
                    |--------------------------------------------------------------------------
                    */

                    credentials: "include"
                }
            );


            /*
            |--------------------------------------------------------------------------
            | Response JSON
            |--------------------------------------------------------------------------
            */

            const data = await response.json();


            console.log(
                "Paper Category Response:",
                data
            );


            /*
            |--------------------------------------------------------------------------
            | Success
            |--------------------------------------------------------------------------
            */

            if (
                response.ok &&
                data.success
            ) {

                setCategories(
                    Array.isArray(data.data)
                        ? data.data
                        : []
                );

            }


            /*
            |--------------------------------------------------------------------------
            | Error
            |--------------------------------------------------------------------------
            */

            else {

                setError(
                    data.message ||
                    "Failed to fetch paper categories."
                );

            }

        } catch (error) {

            console.error(
                "Fetch Paper Category Error:",
                error
            );


            setError(
                "Unable to connect with server."
            );

        } finally {

            setLoading(false);

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Search
    |--------------------------------------------------------------------------
    */

    const filteredCategories =
        categories.filter((item) => {

            const paperName =
                item.paper
                    ? String(item.paper).toLowerCase()
                    : "";


            return paperName.includes(
                search.toLowerCase()
            );

        });


    /*
    |--------------------------------------------------------------------------
    | Pagination
    |--------------------------------------------------------------------------
    */

    const totalPages = Math.ceil(
        filteredCategories.length /
        itemsPerPage
    );


    const startIndex =
        (currentPage - 1) *
        itemsPerPage;


    const currentCategories =
        filteredCategories.slice(
            startIndex,
            startIndex + itemsPerPage
        );


    /*
    |--------------------------------------------------------------------------
    | Search Change
    |--------------------------------------------------------------------------
    */

    const handleSearch = (e) => {

        setSearch(
            e.target.value
        );

        setCurrentPage(1);

    };


    /*
    |--------------------------------------------------------------------------
    | Previous Page
    |--------------------------------------------------------------------------
    */

    const previousPage = () => {

        if (currentPage > 1) {

            setCurrentPage(
                currentPage - 1
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Next Page
    |--------------------------------------------------------------------------
    */

    const nextPage = () => {

        if (
            currentPage < totalPages
        ) {

            setCurrentPage(
                currentPage + 1
            );

        }

    };


    /*
    |--------------------------------------------------------------------------
    | Delete
    |--------------------------------------------------------------------------
    */

    const handleDelete = async (id) => {

    try {

        /*
        |--------------------------------------------------------------------------
        | Confirm Delete
        |--------------------------------------------------------------------------
        */

        const result = await Swal.fire({

            title: "Are you sure?",

            text: "You want to delete this paper category?",

            icon: "warning",

            showCancelButton: true,

            confirmButtonColor: "#d33",

            cancelButtonColor: "#6c757d",

            confirmButtonText: "Yes, delete it!",

            cancelButtonText: "Cancel"

        });


        /*
        |--------------------------------------------------------------------------
        | User Cancelled
        |--------------------------------------------------------------------------
        */

        if (!result.isConfirmed) {

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Delete API
        |--------------------------------------------------------------------------
        */

        const response = await fetch(

            `${API_BASE_URL}/admin/paper-category/${id}`,

            {
                method: "DELETE",

                headers: {
                    "Accept": "application/json"
                },

                credentials: "include"
            }

        );


        /*
        |--------------------------------------------------------------------------
        | Response JSON
        |--------------------------------------------------------------------------
        */

        const data = await response.json();


        console.log(
            "Delete Response:",
            data
        );


        /*
        |--------------------------------------------------------------------------
        | Delete Success
        |--------------------------------------------------------------------------
        */

        if (
            response.ok &&
            data.success
        ) {


            /*
            |--------------------------------------------------------------------------
            | Remove Category From State
            |--------------------------------------------------------------------------
            */

            setCategories(
                (previousCategories) =>

                    previousCategories.filter(
                        (item) =>
                            item.id !== id
                    )

            );


            /*
            |--------------------------------------------------------------------------
            | Page Correction
            |--------------------------------------------------------------------------
            */

            if (
                currentCategories.length === 1 &&
                currentPage > 1
            ) {

                setCurrentPage(
                    currentPage - 1
                );

            }


            /*
            |--------------------------------------------------------------------------
            | Success Alert
            |--------------------------------------------------------------------------
            */

            await Swal.fire({

                icon: "success",

                title: "Deleted!",

                text:
                    data.message ||
                    "Paper category deleted successfully.",

                confirmButtonText: "OK",

                confirmButtonColor: "#198754"

            });


        } else {


            /*
            |--------------------------------------------------------------------------
            | Delete Failed
            |--------------------------------------------------------------------------
            */

            Swal.fire({

                icon: "error",

                title: "Delete Failed",

                text:
                    data.message ||
                    "Unable to delete paper category.",

                confirmButtonText: "OK"

            });

        }


    } catch (error) {


        /*
        |--------------------------------------------------------------------------
        | Network / Server Error
        |--------------------------------------------------------------------------
        */

        console.error(
            "Delete Error:",
            error
        );


        Swal.fire({

            icon: "error",

            title: "Server Error",

            text:
                "Unable to connect with server.",

            confirmButtonText: "OK"

        });

    }

};

    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (loading) {

        return (

            <div className="container-fluid">

                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        minHeight: "300px"
                    }}
                >

                    <div
                        className="spinner-border text-primary"
                        role="status"
                    >

                        <span className="visually-hidden">
                            Loading...
                        </span>

                    </div>

                </div>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Main UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="container-fluid">


            <div className="d-flex justify-content-between align-items-center mb-4">

                <h3 className="mb-0">
                    Paper Categories
                </h3>


                <Link
                    to="/add-category"
                    className="btn btn-primary"
                >
                    + Add Category
                </Link>

            </div>



            {/* =========================================================
                Error
            ========================================================= */}

            {error && (

                <div
                    className="alert alert-danger"
                    role="alert"
                >

                    {error}

                </div>

            )}



            {/* =========================================================
                Card
            ========================================================= */}

            <div className="card shadow-sm">


                {/* =====================================================
                    Card Header
                ===================================================== */}

                <div className="card-header bg-white">

                    <div className="row align-items-center">


                        {/* Search */}

                        <div className="col-md-4">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Category..."
                                value={search}
                                onChange={handleSearch}
                            />

                        </div>


                        {/* Total */}

                        <div className="col-md-8 text-md-end mt-3 mt-md-0">

                            <span className="text-muted">

                                Total Categories:{" "}

                                <strong>
                                    {filteredCategories.length}
                                </strong>

                            </span>

                        </div>

                    </div>

                </div>



                {/* =====================================================
                    Table
                ===================================================== */}

                <div className="card-body p-0" style={{
                            maxHeight: "350px",
                            overflowX: "auto",
                            overflowY: "auto"
                        }}>

                   <div className="table-responsive">
    


                        <table className="table table-hover align-middle mb-0">


                            {/* =================================================
                                Table Header
                            ================================================= */}

                            <thead className="table-light">

                                <tr>

                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Paper Category
                                    </th>

                                    <th>
                                        Price
                                    </th>

                                    <th>
                                        Duration
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                    <th width="220">
                                        Action
                                    </th>

                                </tr>

                            </thead>



                            {/* =================================================
                                Table Body
                            ================================================= */}

                            <tbody>


                                {currentCategories.length === 0 ? (

                                    <tr>

                                        <td
                                            colSpan="6"
                                            className="text-center py-5"
                                        >

                                            <div className="text-muted">

                                                No paper categories found.

                                            </div>

                                        </td>

                                    </tr>

                                ) : (

                                    currentCategories.map(
                                        (item, index) => (

                                            <tr
                                                key={item.id}
                                            >


                                                {/* Number */}

                                                <td>

                                                    {startIndex +
                                                        index +
                                                        1}

                                                </td>



                                                {/* Paper */}

                                                <td>

                                                    <strong>
                                                        {item.paper}
                                                    </strong>

                                                </td>



                                                {/* Price */}

                                                <td>

                                                    ₹ {item.price}

                                                </td>



                                                {/* Duration */}

                                                <td>

                                                    {item.duration}

                                                </td>



                                                {/* Status */}

                                                <td>

                                                    {String(
                                                        item.status
                                                    ).toLowerCase() ===
                                                    "enable" ? (

                                                        <span className="badge bg-success">
                                                            Enable
                                                        </span>

                                                    ) : (

                                                        <span className="badge bg-danger">
                                                           Disable
                                                        </span>

                                                    )}

                                                </td>



                                                {/* Actions */}

                                                <td>


                                                    {/* Edit */}

                                                   <Link
                                                        to={`/edit-category/${item.id}?name=${encodeURIComponent(item.paper)}`}
                                                        className="btn btn-sm btn-warning me-2"
                                                    >
                                                        Edit
                                                    </Link>



                                                    {/* Delete */}

                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() =>
                                                            handleDelete(
                                                                item.id
                                                            )
                                                        }
                                                    >
                                                        Delete
                                                    </button>


                                                </td>


                                            </tr>

                                        )
                                    )

                                )}

                            </tbody>


                        </table>

                    </div>

                </div>



                {/* =========================================================
                    Pagination
                ========================================================= */}

                {totalPages > 0 && (

                    <div className="card-footer bg-white">

                        <div className="d-flex justify-content-between align-items-center">


                            {/* Showing */}

                            <div className="text-muted small">

                                Showing{" "}

                                <strong>
                                    {startIndex + 1}
                                </strong>

                                {" "}to{" "}

                                <strong>

                                    {Math.min(
                                        startIndex +
                                        itemsPerPage,
                                        filteredCategories.length
                                    )}

                                </strong>

                                {" "}of{" "}

                                <strong>
                                    {filteredCategories.length}
                                </strong>

                            </div>



                            {/* Pagination */}

                            <div>


                                {/* Previous */}

                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary me-2"
                                    onClick={previousPage}
                                    disabled={
                                        currentPage === 1
                                    }
                                >
                                    Previous
                                </button>



                                {/* Page */}

                                <span className="mx-2">

                                    Page{" "}

                                    <strong>
                                        {currentPage}
                                    </strong>

                                    {" "}of{" "}

                                    <strong>
                                        {totalPages}
                                    </strong>

                                </span>



                                {/* Next */}

                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary ms-2"
                                    onClick={nextPage}
                                    disabled={
                                        currentPage ===
                                        totalPages
                                    }
                                >
                                    Next
                                </button>


                            </div>


                        </div>

                    </div>

                )}


            </div>

        </div>

    );

}

export default PaperCategory;